export const getNameInitials = (name) => {
	if (!name) return;
	const nameParts = name.split(" ");
	const firstName = nameParts[0];
	const lastName = nameParts[1];
	return `${firstName ? firstName.charAt(0) : ""}${
		lastName ? lastName.charAt(0) : ""
	}`;
};
